
import "../styles/app.scss";
import Splide from "@splidejs/splide";

var elms = document.getElementsByClassName( 'horizontalsliderblock' );
for ( var i = 0, len = elms.length; i < len; i++ ) {
	new Splide( elms[ i ], {
        type     : 'slide',
        autoWidth: true,
        focus    : 'left',
    } ).mount();
}


var elms = document.getElementsByClassName( 'bannersliderblock' );
for ( var i = 0, len = elms.length; i < len; i++ ) {
	new Splide( elms[ i ], {
        type     : 'loop',
        autoplay : 500,
    } ).mount();
}

var elmsx = document.getElementsByClassName( 'modalsliderblock' );
for ( var i = 0, len = elmsx.length; i < len; i++ ) {
	new Splide( elmsx[ i ], {
        type     : 'loop',
        interval: 4000,
        speed: 400,
        autoplay : 'play',
    } ).mount();
}

import { toggle } from "./toggle/toggle.js";
import { cookiePolicy } from "./cookiepolicy/cookiepolicy.js";
import { multilevel } from "./multilevel-nav/multilevel-nav.js";
import { windowheight } from "./windowheight/windowheight.js";
// import LazyLoad from "vanilla-lazyload";


let CookiesEuBanner = new cookiePolicy();
let Multilevel = new multilevel('.menu, .sub-menu');
let toggleNavicon = new toggle( 'data-linknavicon', 'data-targetnavicon', 'active' );
let toggleInstance = new toggle( 'data-link', 'data-target', 'active' );
let WindowHeight = new windowheight();

import lib from "./lib/lib";
import toggler from "./lib/toggler";
import cacher from "./lib/cacher";
import cacherSession from "./lib/cacherSession";

export function main() {    
    return (
        console.log('Astridr JS Started')
    );
} 

// var myLazyLoad = new LazyLoad(); 
// myLazyLoad.update();


console.log('abc');

window.state = {
    popupModal: {
      name: "popupModal",
      current: "open",
      opt: ["closed", "open"],
      body: true,
      bodyclss: "popupModal",
    },
    video: [], // Used for Normal MP4 Files
    vimeo: [], // Used for Vimeo Videos
    wistia: [], // Used for Wistia Videos
  };
  

  window.App = {
    load_cache: (data = false) => {
        // state["popupModal"] = cacherSession.retrieve("popupModal")
        // ? cacherSession.retrieve("popupModal")
        // : state.popupModal;
    },
    global_scope: (data = false) => {},
    scope: (data = false) => {
        setTimeout(() => { 
            toggler.toggle(lib.qsa('.js--popupModal-toggle'), state.popupModal, App.render.bind(this, state));
      
            // lib.qs('.modal--popup .single-btn').addEventListener('click', () => {
            //   state.popupModal.current = 'closed';
      
            //   cacherSession.store("popupModal", state.popupModal);
            // });
      
          }, 1);
    },
    render: (data = false) => {
        cacherSession.store("popupModal", state.popupModal);
    },
};
    
window.onload = function () {
    App.load_cache();
    App.global_scope();
    App.scope();
};
